
  
  function initPaintCalculator (){
  
  const modal = document.getElementById("paintCalculatorModal");
  const openBtn = document.getElementById("openPaintCalculator");
  const closeBtn = document.querySelector(".close-paint");
  const calculateBtn = document.getElementById("calculatePaint");
  const resultText = document.getElementById("results");
  const paintTypeRadios = document.querySelectorAll('input[name="paintType"]');
  const lengthInput = document.getElementById("length");
  const statusText = document.querySelector(".heading-cat-cal em"); // Status paragraph

  const resetBtn = document.getElementById("resetCalculator");
  // Input fields
  const inputs = {
    length: document.getElementById("length"),
    width: document.getElementById("width"),
    height: document.getElementById("height"),
    doors: document.getElementById("doors"),
    width_door: document.getElementById("width_door"),
    height_door: document.getElementById("height_door"),
    windows: document.getElementById("windows"),
    width_window: document.getElementById("width_window"),
    height_window: document.getElementById("height_window")
  };

  // Add Status Text
  statusText.id = "statusText";
  statusText.style.marginBottom = "10px";
  statusText.textContent = "Room dimensions";

  // Open Modal

   document.querySelectorAll('.custom-paint-link').forEach(link => {
    link.addEventListener("click", function (event) {
      console.log("clicked")
      event.preventDefault(); // Prevent default anchor behavior
      modal.style.display = "flex";
      gsap.to(".modal-content-paint",{
        x:0,
        duration: 0.7
      })
      
     
    });
  });



  // Close Modal
  closeBtn.addEventListener("click", function () {
    

  gsap.to(".modal-content-paint",{
        x:"100%",
        duration: 0.7,
        onComplete:()=>{
          modal.style.display = "none";
        }
      })
  });

  // Close Modal on Click Outside
  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      
       gsap.to(".modal-content-paint",{
        x:"100%",
        duration: 0.7,
        onComplete:()=>{
          modal.style.display = "none";
        }
      })
    }
  });

  // Listen for Paint Type Selection & Update Status
  paintTypeRadios.forEach((radio) => {
    radio.addEventListener("change", function () {
      if (this.value === "wall") {
        lengthInput.disabled = true;
        lengthInput.style.opacity = "0";
        statusText.textContent = "Wall dimensions";
      } else {
        lengthInput.disabled = false;
        lengthInput.style.opacity = "1";
        statusText.textContent = "Room dimensions";
      }
    });
  });

  // Prevent Negative Numbers
  document.querySelectorAll("input[type='number']").forEach((input) => {
    input.addEventListener("input", function () {
      if (this.value < 0) this.value = 0;
    });
  });

  // Calculate Paint Function
  calculateBtn.addEventListener("click", function () {
    const paintType = document.querySelector('input[name="paintType"]:checked').value;

    // Get Dimensions
    const width = parseFloat(document.getElementById("width").value) || 0;
    const height = parseFloat(document.getElementById("height").value) || 0;
    let sqFootage = 0;

    if (paintType === "room") {
      const length = parseFloat(document.getElementById("length").value) || 0;
      sqFootage = ((length * height) + (width * height)) * 2;
    } else if (paintType === "wall") {
      sqFootage = width * height;
    }

    // Get Doors & Windows Data
    const doors = parseInt(document.getElementById("doors").value) || 0;
    const doorWidth = parseFloat(document.getElementById("width_door").value) || 0;
    const doorHeight = parseFloat(document.getElementById("height_door").value) || 0;
    const windows = parseInt(document.getElementById("windows").value) || 0;
    const windowWidth = parseFloat(document.getElementById("width_window").value) || 0;
    const windowHeight = parseFloat(document.getElementById("height_window").value) || 0;

    // Calculate Doors & Windows Area
    const doorArea = doors * (doorWidth * doorHeight);
    const windowArea = windows * (windowWidth * windowHeight);

    // Final Paintable Area
    const finalArea = sqFootage - doorArea - windowArea;

    // Prevent Negative Final Area
    if (finalArea <= 0) {
      resultText.innerHTML = "Error: Your inputs result in a negative or zero paintable area. Please adjust your values.";
      return;
    }

    // Determine Gallons Needed
    let coat1 = 0, coat2 = 0;

    if (finalArea >= 0 && finalArea <= 200) { coat1 = 0.5; coat2 = 1; }
    else if (finalArea <= 400) { coat1 = 1; coat2 = 2; }
    else if (finalArea <= 600) { coat1 = 1.5; coat2 = 3; }
    else if (finalArea <= 800) { coat1 = 2; coat2 = 4; }
    else if (finalArea <= 1000) { coat1 = 2.5; coat2 = 5; }
    else if (finalArea <= 1200) { coat1 = 3; coat2 = 6; }
    else if (finalArea <= 1400) { coat1 = 3.5; coat2 = 7; }
    else if (finalArea <= 1600) { coat1 = 4; coat2 = 8; }
    else if (finalArea <= 1800) { coat1 = 4.5; coat2 = 9; }
    else if (finalArea <= 2000) { coat1 = 5; coat2 = 10; }
    else if (finalArea <= 2200) { coat1 = 5.5; coat2 = 11; }
    else if (finalArea <= 2400) { coat1 = 6; coat2 = 12; }
    else if (finalArea <= 2600) { coat1 = 6.5; coat2 = 13; }
    else if (finalArea <= 2800) { coat1 = 7; coat2 = 14; }
    else if (finalArea <= 3000) { coat1 = 7.5; coat2 = 15; }

    if (finalArea <= 3000){
    // Display Results
    resultText.innerHTML = `<p class="result-text-h4 h6">Your ${paintType} is ${finalArea.toFixed(2)} sqft, so we recommend:</p>
    <p class="h4">${coat1} gallons for 1 coat.</p>
    <p class="h4">${coat2} gallons for 2 coats.</p>`;
    } else if (finalArea > 3000){
 resultText.innerHTML = `
    <p class="h6">The area that you are trying to cover needs a custom calculation. <br> Please contact us for a custom made quotation.</p>`;
    }
  });

   // Reset Functionality
  resetBtn.addEventListener("click", () => {
    Object.values(inputs).forEach(input => input.value = ""); // Clear all inputs
    resultText.innerHTML = ""; // Clear result text
   lengthInput.disabled = false;// Enable length input

        lengthInput.style.opacity = "1";
    document.querySelector("input[name='paintType'][value='room']").checked = true; // Reset paint type to 'room'
    statusText.textContent = "Room dimensions";
  });
  }

initPaintCalculator()
document.addEventListener("variant:change", function() {
  console.log("variant change")
  initPaintCalculator(); // Re-initialize after variant change
});
